module.exports = __webpack_public_path__ + "static/media/check_on.cad69015.svg";